export class Bundesland {
  constructor(name: string, isSelected: boolean) {
    this.name = name;
    this.isSelected = isSelected;
  }

  name;
  isSelected = false;

}

export enum BundesLandName {
  BB = 'Brandenburg',
  BY = 'Bayern',
  BW = 'Baden-Württemberg',
  BE = 'Berlin',
  HB = 'Freie Hansestadt Bremen',
  HH = 'Hamburg',
  HE = 'Hessen',
  MV = 'Mecklenburg-Vorpommern',
  NI = 'Niedersachsen',
  NW = 'Nordrhein-Westfalen',
  RP = 'Rheinland-Pfalz',
  SL = 'Saarland',
  SN = 'Sachsen',
  ST = 'Sachsen-Anhalt',
  SH = 'Schleswig-Holstein',
  TH = 'Thüringen'
}

export enum BundeslandCode {
  BW = 'BW',
  BY = 'BY',
  BE = 'BE',
  BB = 'BB',
  HB = 'HB',
  HH = 'HH',
  HE = 'HE',
  MV = 'MV',
  NI = 'NI',
  NW = 'NW',
  RP = 'RP',
  SL = 'SL',
  SN = 'SN',
  ST = 'ST',
  SH = 'SH',
  TH = 'TH'
}
